import { Component } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import logo from '../../assets/images/logo_new.png';
import { Agree, Success } from './components';
import { termsBodySx } from '../../common/styles/commonStyles';
import {
  Grid,
  Box,
  AppBar,
  Toolbar,
  Fab
} from '@mui/material';

class Terms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      terms: true,
      success: false
    };
  }

  showSuccess() {
    this.setState({
      terms: false,
      success: true
    });
  }

  render() {
    return (
      <Box sx={{ mb: 5 }}>
        <AppBar
          position="relative"
          sx={{
            background: 'transparent',
            boxShadow: 'none',
            py: 2.5
          }}
        >
          <Toolbar sx={{ p: '0 !important' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'start',
                justifyContent: 'start',
                width: '100%'
              }}
            >
              <RouterLink to="/">
                <Box
                  component="img"
                  alt="Logo"
                  src={logo}
                  sx={{
                    width: 175,
                    display: 'block',
                    '@media (max-width:600px)': {
                      width: 125
                    }
                  }}
                />
              </RouterLink>
            </Box>
          </Toolbar>
        </AppBar>

        <Grid container>
          <Grid size={{ xs: 12 }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                px: {
                  xs: '5px',
                  md: 0
                },
                pb: 5,
                mt: 2,
                width: '100%',
                maxWidth: '900px',
                margin: 'auto'
              }}
            >
              {this.state.terms && (
                <Box component="span" sx={termsBodySx}>
                  <Agree />

                  <Box
                    sx={{
                      display: 'flex',
                      flex: 1,
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap:2
                    }}
                  >
                    <Fab
                      variant="extended"
                      size="medium"
                      color="primary"
                      aria-label="accept terms"
                      onClick={() => this.showSuccess()}
                      sx={{
                        width: 'auto',
                        mt: 2.5,
                        px: '30px !important',
                        py: '10px',
                        lineHeight: '16px'
                      }}
                    >
                      Agree
                    </Fab>

                    <Fab
                      variant="extended"
                      size="medium"
                      aria-label="cancel"
                      component={RouterLink}
                      to="/sign-up"
                      sx={{
                        width: 'auto',
                        mt: 2.5,
                        px: '30px !important',
                        py: '10px',
                        lineHeight: '16px',
                        backgroundColor: '#EAEAEA',
                        color: '#000',
                        '&:hover': {
                          backgroundColor: '#D8D8D8'
                        }
                      }}
                    >
                      Cancel
                    </Fab>
                  </Box>
                </Box>
              )}

              {this.state.success && <Success />}
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

Terms.propTypes = {
  history: PropTypes.object
};

export default withRouter(Terms);